import React, { useContext, useEffect, useMemo } from 'react';
import { MFProvider } from '@4r/mf-host';
import {
  AccessContext,
  AccessProvider,
  UserModel,
} from '@4r/module-common-authorization';
import './MainContainer.scss';
import './globalStyleFixes.scss';
import {
  Config,
  ConfigContextProvider,
  useApiClient,
} from '@4r/module-common-mf-app';
import { AttendanceClient } from '@@api';
import { registerCommandHandlers } from '@@handlers';
import PermissionType from '../authorization/PermissionType';

export interface IMainContainerProps {
  settings: Config;
  currentUser: UserModel;
}

interface IMainChildContainerProps {
  currentUser: UserModel;
}

const MainChildContainer: React.FC<
  React.PropsWithChildren<IMainChildContainerProps>
> = ({ currentUser, children }) => {
  const access = useContext(AccessContext);
  const attendanceClient = useApiClient(AttendanceClient);

  useEffect(
    () => registerCommandHandlers(attendanceClient),
    [attendanceClient],
  );

  React.useEffect(() => {
    if (currentUser) {
      access.setUserAndPermissions(currentUser);
    }
  }, [currentUser]);

  const visible = useMemo(
    () => access && access.loaded && access.has(PermissionType.ViewWebClock), // all the containers shoudl be accessible only if the user has this perm
    [access],
  );

  return <>{visible && children}</>;
};

const MainContainer: React.FC<React.PropsWithChildren<IMainContainerProps>> = ({
  settings,
  currentUser,
  children,
}) => (
  <div className="mf-time-attendance">
    {settings && currentUser && (
      <MFProvider>
        <ConfigContextProvider config={settings}>
          <AccessProvider>
            <MainChildContainer currentUser={currentUser}>
              {children}
            </MainChildContainer>
          </AccessProvider>
        </ConfigContextProvider>
      </MFProvider>
    )}
  </div>
);

export default MainContainer;
